import { useState } from 'react';
import { Link } from 'react-router-dom';
import isEmail from 'validator/lib/isEmail';

import useAuth from '../../auth/useAuth';
import { requestEmailChange } from '../../services/userService';
import '../Login/Login.css';
import './ChangeEmailPage.css';

const ChangeEmailPage = () => {
  const { user } = useAuth();
  const [newEmail, setNewEmail] = useState('');
  const [currentPassword, setCurrentPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (submitting) return;

    const normalizedEmail = newEmail.trim().toLowerCase();
    setError('');

    if (!normalizedEmail) return setError('New email is required.');
    if (!isEmail(normalizedEmail)) return setError('Enter a valid e-mail address.');
    if (normalizedEmail === user.email.toLowerCase()) {
      return setError('The new email address must be different from your current email.');
    }
    if (!currentPassword) return setError('Current password is required.');

    setSubmitting(true);
    try {
      await requestEmailChange(normalizedEmail, currentPassword);
      setSubmitted(true);
    } catch (requestError) {
      const status = requestError?.response?.status;
      if (status === 400 || status === 409) {
        setError(requestError.response.data.message);
      } else {
        setError('Unable to process the email change. Please try again later.');
      }
    } finally {
      setSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <main className="loginPage">
        <section className="loginCard changeEmailResult">
          <h1>Check your new email</h1>
          <p>A verification link has been sent to your new email address.</p>
          <p>Your current email will remain active until the new address is verified.</p>
          <p>The link expires in 24 hours.</p>
          <Link className="loginSubmitButton changeEmailBack" to="/profile">
            Back to Profile
          </Link>
        </section>
      </main>
    );
  }

  return (
    <main className="loginPage">
      <section className="loginCard changeEmailCard">
        <h1>Change email</h1>
        <div className="changeEmailCurrent">
          <strong>Current email</strong>
          <span>{user.email}</span>
        </div>
        <form className="loginForm" onSubmit={handleSubmit} noValidate>
          <div className="loginField">
            <label htmlFor="change-email-new">New email</label>
            <input id="change-email-new" type="email" inputMode="email" autoComplete="email" placeholder="name@example.com" value={newEmail} onChange={(event) => setNewEmail(event.target.value)} disabled={submitting} />
          </div>
          <div className="loginField">
            <label htmlFor="change-email-password">Current password</label>
            <div className="loginPasswordControl">
              <input id="change-email-password" type={showPassword ? 'text' : 'password'} autoComplete="current-password" value={currentPassword} onChange={(event) => setCurrentPassword(event.target.value)} disabled={submitting} />
              <button className="loginPasswordToggle" type="button" aria-label={showPassword ? 'Hide password' : 'Show password'} aria-pressed={showPassword} onClick={() => setShowPassword((value) => !value)} disabled={submitting}>
                <span aria-hidden="true">{showPassword ? '\u25C9' : '\u25CB'}</span>
              </button>
            </div>
          </div>
          {error && <p className="loginError" role="alert">{error}</p>}
          <button className="loginSubmitButton" type="submit" disabled={submitting}>
            {submitting ? 'Sending verification link...' : 'Send verification link'}
          </button>
        </form>
        <p className="loginRegisterText"><Link to="/profile">Back to Profile</Link></p>
      </section>
    </main>
  );
};

export default ChangeEmailPage;
